<template>
    <!-- Register section -->
    <section class="login-page">
        <div class="container">
            <div class="login">
                <h1 class="heading-title text-center">Create a new acconut</h1>
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-8 col-lg-6">
                        <form>
                            <div class="form-row  align-items-center justify-content-center">

                                <div class="form-group col-md-12">
                                    <label for="name" class="required">Name</label>
                                    <input type="text" class="form-control input" id="name" placeholder="Name" v-model="user.name">
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="email" class="required">Email</label>
                                    <input type="email" class="form-control input" id="email" placeholder="Email" v-model="user.email">
                                </div>
        
                                <div class="form-group col-md-12">
                                    <label for="passwoed" class="required">Password</label>
                                    <input type="password" class="form-control input" id="passwoed"
                                        placeholder="Password" v-model="user.password">
                                </div>

                                <div class="form-group col-12">
                                    <button type="button" class="btn main-btn w-100" @click="signUp">Sign Up</button>
                                </div>

                                <div class="form-group col-12 d-flex justify-content-around flex-wrap">
                                    <a href="#" class="btn login-link facebook">facebook</a>
                                    <a href="#" class="btn login-link google">Google</a>
                                    <div class="w-100 text-center new-account">Have an account? <a href="#">Login</a>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="col-lg-6 d-none d-lg-block">
                        <div class="image">
                            <img src="@/assets/app/images/login.png" alt="login-image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--end Register section -->
</template>

<script>
import "../../sass/login.scss";
export default {
    name: "login",
    data() {
        return {
            user: {
                name: "",
                email: "",
                password: ""
            }
        }
    },
    computed: {
        auth() {
             return this.$store.getters["authModule/getUser"];
        }
    },
    methods: {
        signUp() {
            this.$store.dispatch("authModule/signUp", this.user);
        }
    },
    watch: {
        auth(value) {
            value ? this.$router.push("/") : "";
        }
    }
}
</script>
